export enum Roles {
  Client = 'aw-client-role',

  Customer = 'aw-customer-role',
  SalesOrderCustomer = 'aw-sales-order-customer-role',

  ESS = 'aw-hcm-ess-role',
  FinanceTimesheet = 'aw-finance-timesheet-role',
  FinanceTimesheetApprover = 'aw-finance-timesheet-approver-role',
  FinanceExpense = 'aw-finance-expense-role',
  MSS = 'aw-hcm-mss-role',

  CalendarAdminRole = 'aw-hcm-calendar-admin-role',
  FinanceCalendarAdminRole = 'aw-finance-calendar-admin-role',

  HrGeneralist = 'aw-hcm-generalist-role',
  HrRecruiter = 'aw-hcm-recruiter-role',
  HrRecruit2Hier = 'aw-hcm-recruit2hire-role',

  HcmCandidate = 'aw-hcm-candidate-role',

  GeneralLedgerAdmin = 'aw-finance-gl-admin-role',
  ChartOfAccountAdmin = 'aw-coa-admin-role',
  ChargeCodeAdmin = 'aw-cc-admin-role',
  FinanceTimesheetAdmin = 'aw-timesheet-admin-role',
  PaymentTermsAdmin = 'aw-payment-terms-admin-role',

  AR = 'aw-ar-role',
  SalesOrder = 'aw-sales-order-role',
  MaterialOrder = 'aw-material-order-role',
  PackingSlip = 'aw-packing-slip-role',
  SalesReturn = 'aw-sales-return-role',

  AP = 'aw-ap-role',
  ItemCatalogAdmin = 'aw-catalog-admin-role',
  Procurement = 'aw-procurement-role',
  ItemReturn = 'aw-item-return-role',
  ItemReceipt = 'aw-item-receipt-role',
  VoucherRegister = 'aw-voucher-register-admin-role',

  Project = 'aw-project-role',
  Contract = 'aw-contract-role',

  PayrollAdmin = 'aw-payroll-admin-role',

  OrgAdmin = 'aw-org-admin-role',
  CSRAdmin = 'aw-csr-admin-role',
  CyberPlanAdmin = 'aw-cyber-plan-admin-role',

  AccountantSME = 'aw-accountant-sme-role',

  ProjectContractDashboard = 'aw-project-contract-dashboard-role',
  FinanceDashboard = 'aw-finance-dashboard-role',
  HcmDashboard = 'aw-hcm-dashboard-role',
  ProcurementDashboard = 'aw-procurement-dashboard-role',
  ExecutiveDashboard = 'aw-executive-dashboard-role',
  SupportFile = 'aw-support-file-role',

  CyberplanCertifier = 'aw-cyberplan-certifier-role',
  CyberplanAssessor = 'aw-cyberplan-assessor-role',
  CyberplanRemediator = 'aw-cyberplan-remediator-role',

  CyberplanCustomer = 'aw-cyberplan-customer-role',

  // QuickBooks Timesheet import
  QuickBooksTimeConfigRole = 'aw-quickbooks-time-config-role',
  QuickBooksTimeImportRole = 'aw-quickbooks-time-import-role',
  ManualTimesheetsImportRole = 'aw-manual-time-import-role',

  ReportingRole = "aw-reporting-role",

  // Implementation admin roles
  ImplementationAdminRole = 'aw-implementation-admin-role',
  DataImportRole = 'aw-data-import-role'

}
